import { Text } from '@findy-code/yuffie/ui/text';

import type { SectionIds } from './company-detail.presenter';
import { useSectionScrollObserverContext } from './company-detail.presenter';
import styles from './company-detail-section-navigator.component.module.scss';

const linkLists = [
  {
    id: 'mission',
    label: 'ミッション',
  },
  {
    id: 'vision',
    label: 'ビジョン',
  },
  {
    id: 'product',
    label: 'プロダクト',
  },
  {
    id: 'interview',
    label: 'インタビュー',
  },
  {
    id: 'events',
    label: '企業特集動画',
  },
  {
    id: 'entries',
    label: '技術ブログ',
  },
  {
    id: 'member',
    label: 'メンバー',
  },
  {
    id: 'press-release',
    label: 'プレスリリース',
  },
  // MEMO: NEXT_PUBLIC_FEATURE_UPDATE_COMPANY_SUMMARYの削除タイミングで削除する
  {
    id: 'basic-information',
    label: '基本情報',
  },
  {
    id: 'summary',
    label: '会社概要',
  },
  {
    id: 'git-hub',
    label: '公式GitHub',
  },
  {
    id: 'skills',
    label: '利用技術',
  },
  {
    id: 'links',
    label: '関連リンク',
  },
] as const;

export const CompanyDetailSectionNavigator = ({
  sectionVisibility,
}: {
  sectionVisibility: { [key in SectionIds]: boolean };
}) => {
  const { activeSection } = useSectionScrollObserverContext();
  return (
    <nav aria-label="目次" className={styles.nav}>
      <ul>
        {linkLists
          .filter((link) => sectionVisibility[link.id])
          .map((link) => (
            <li key={link.id}>
              <a href={`#${link.id}`}>
                <Text
                  font="body-s"
                  style={{
                    fontWeight: activeSection === link.id ? 'bold' : 'normal',
                  }}
                >
                  {link.label}
                </Text>
              </a>
            </li>
          ))}
      </ul>
    </nav>
  );
};
